import { api } from './api';

export interface AuditEvent {
  id: string;
  action: string;
  description: string;
  actor_type: string;
  actor_id: string | null;
  actor_label: string | null;
  resource_type: string | null;
  resource_id: string | null;
  project_id: string | null;
  ip: string | null;
  user_agent: string | null;
  request_id: string | null;
  metadata: Record<string, unknown>;
  created_at: string;
}

export interface AuditEventsFilters {
  action?: string[];
  actor_type?: string;
  actor_id?: string;
  resource_type?: string;
  project_id?: string;
  from?: string;
  to?: string;
  limit?: number;
  cursor?: string;
}

export interface AuditEventsResponse {
  success: boolean;
  data: AuditEvent[];
  pagination: {
    limit: number;
    next_cursor: string | null;
    has_more: boolean;
  };
}

export interface AuditActionsCatalog {
  success: boolean;
  data: {
    actions: string[];
    categories: Record<string, Array<{ action: string; description: string }>>;
    actor_types: string[];
  };
}

function toQueryString(filters: AuditEventsFilters): string {
  const params = new URLSearchParams();
  // `action` is a reserved Rails param (holds the controller action name), so
  // the server expects filters under `actions[]`.
  if (filters.action) filters.action.forEach(a => params.append('actions[]', a));
  if (filters.actor_type) params.set('actor_type', filters.actor_type);
  if (filters.actor_id) params.set('actor_id', filters.actor_id);
  if (filters.resource_type) params.set('resource_type', filters.resource_type);
  if (filters.project_id) params.set('project_id', filters.project_id);
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.cursor) params.set('cursor', filters.cursor);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const auditEventsApi = {
  list: (orgId: string, filters: AuditEventsFilters = {}) =>
    api.get<AuditEventsResponse>(
      `/api/organizations/${orgId}/audit-events${toQueryString(filters)}`
    ),

  actionsCatalog: (orgId: string) =>
    api.get<AuditActionsCatalog>(`/api/organizations/${orgId}/audit-events/actions`),

  csvUrl: (orgId: string, filters: AuditEventsFilters = {}) =>
    `/api/organizations/${orgId}/audit-events.csv${toQueryString(filters)}`,
};
